<template>
    <div>
        <div class="row d-flex align-items-end">
            <div class="col-sm-3 col-md-2 form-group">
                <label for="filtro">Total de leitos</label>
                <input id="filtro" class="form-control" :value="pacientesInternados.mapaLeitos.length" disabled>
            </div>
            <div class="col-sm-3 col-md-2 form-group">
                <label for="filtro">Leitos ocupados</label>
                <input id="filtro" class="form-control" :value="pacientesInternados.mapaLeitos.filter(i => i.leitoStatus == 1).length" disabled>
            </div>
            <div class="col-sm-6 col-md-4 form-group">
                <label for="filtro">Filtrar</label>
                 <div class="input-group">
                    <input class="form-control" :value="filtro.toUpperCase()" @input="filtro = $event.target.value.toUpperCase()">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" @click="filtro = ''" :disabled="filtro == '' ? true : false">Limpar</button>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-3 form-group">
                <button type="button" class="btn btn-success">
                    <download-excel
                        :data="listagem"
                        :fields="excelColunas"
                        worksheet="Leitos"
                        name="pacientesinternados.xls"
                        >
                        <i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel <small v-if="filtro != ''">(dados filtrados)</small>
                    </download-excel>
                </button>
            </div>
        </div>

        <p v-if="filtro != ''">Resultados do filtro:<strong> {{listagem.length}}</strong></p>

        <b-table
            responsive
            striped
            bordered
            hover
            thead-class="tcabecario"
            :items="listagem"
            :fields="colunas"
            :current-page="currentPage"
            :per-page="12"
        >
            <template slot="leitoStatus" slot-scope="row">
                <div v-html="verificaStatus(row.item.leitoStatus)"></div>
            </template>
            <template slot="tempoInternado" slot-scope="row">
                <div v-html="tempo(row.item.DataHoraInternacao)"></div>
            </template>
        </b-table>

        <b-row>
            <b-col md="6" class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="12"
                ></b-pagination>
            </b-col>
        </b-row>
        
    </div>
</template>

<script>
export default {
    mounted () {
        this.totalRows = this.pacientesInternados.mapaLeitos.length
    },
    data() {
        return {
            colunas: [
                { key: 'leitoCodigoEnfermaria', label: 'Cód. Enfermaria', class: 'text-center' },
                { key: 'leitoCodigo', label: 'Leito', class: 'text-center' },
                { key: 'leitoStatus', label: 'Status', class: 'text-center' },
                { key: 'tipoClinicoNome', label: 'Tipo Clínico', class: 'text-center' },
                { key: 'pacienteNome', label: 'Nome do Paciente', class: 'text-center' },
                { key: 'pacienteCns', label: 'CNS do Paciente', class: 'text-center' },
                { key: 'pacienteDataNascimento', label: 'Dt. Nascimento', class: 'text-center' },
                { key: 'DataHoraInternacao', label: 'Data/Hora da Admissão', class: 'text-center' },
                { key: 'tempoInternado', label: 'Tempo Internado', class: 'text-center' },
            ],
            totalRows: 1,
            currentPage: 1,
            filtro: '',
            excelColunas: {
                'Cod Enfermaria': 'leitoCodigoEnfermaria',
                'Leito': 'leitoCodigo',
                'Status': 'nomeStatus',
                'Tipo Clínico': 'tipoClinicoNome',
                'Nome do Paciente': 'pacienteNome',
                'CNS do Paciente Internado':  {
                    field: 'pacienteCns',
                    callback: (value) => {
                        if (value == '') return ''
                        else return `="${value}"`;
                    }
                },
                'Nascimento do Paciente': 'pacienteDataNascimento',
                'Data Hora da Admissão': 'DataHoraInternacao'
            }
        }
    },
    computed: {
        pacientesInternados () {
            return this.$store.getters['relatorios/getPacientesInternados']
        },
        listagem () {
            let items = new Array()

            this.pacientesInternados.mapaLeitos.forEach(i => {
                let dados = {
                    leitoCodigoEnfermaria: i.leitoCodigoEnfermaria.toString(),
                    leitoCodigo: i.leitoCodigo,
                    leitoStatus: i.leitoStatus,
                    tipoClinicoNome: i.tipoClinicoNome,
                    pacienteNome: i.pacienteNome,
                    pacienteCns: i.pacienteCns,
                    pacienteDataNascimento: i.pacienteDataNascimento,
                    DataHoraInternacao: i.DataHoraInternacao,
                }

                if (dados.leitoStatus === 0) dados.nomeStatus = 'LIVRE'
                if (dados.leitoStatus === 1) dados.nomeStatus = 'OCUPADO'
                if (dados.leitoStatus === 2) dados.nomeStatus = 'IMPEDIDO'
                if (dados.leitoStatus === 3) dados.nomeStatus = 'CEDIDO'
                if (dados.leitoStatus === 4) dados.nomeStatus = 'REGULADO'
                if (dados.leitoStatus === 5) dados.nomeStatus = 'RESERVADO'

                if (!dados.pacienteNome) dados.pacienteNome = ''
                if (!dados.pacienteCns) dados.pacienteCns = ''
                if (!dados.pacienteDataNascimento) dados.pacienteDataNascimento = ''
                if (!dados.DataHoraInternacao) dados.DataHoraInternacao = ''

                items.push(dados)
            });

            if (this.filtro == '') return items
            else return items.filter(i =>
                i.pacienteNome.includes(this.filtro) ||
                i.nomeStatus.includes(this.filtro) ||
                i.tipoClinicoNome.includes(this.filtro) ||
                i.pacienteCns.includes(this.filtro) ||
                i.tipoClinicoNome.includes(this.filtro) ||
                i.DataHoraInternacao.includes(this.filtro) ||
                i.leitoCodigoEnfermaria.includes(this.filtro) ||
                i.pacienteDataNascimento.includes(this.filtro)
            )

        }
    },
     methods: {
        verificaStatus (status) {
            if (status == 0) return '<button type="button" class="btn btn-success btn-sm btn-block">Livre</button>'
            if (status == 1) return '<button type="button" class="btn btn-secondary btn-sm btn-block">Ocupado</button>'
            if (status == 2) return '<button type="button" class="btn btn-danger btn-sm btn-block">Impedido</button>'
            if (status == 3) return '<button type="button" class="btn btn-primary btn-sm btn-block">Cedido</button>'
            if (status == 4) return '<button type="button" class="btn btn-primary btn-sm btn-block">Regulado</button>'
            if (status == 5) return '<button type="button" class="btn btn-warning btn-sm btn-block">Reservado</button>'
        },
        tempo (data) {
            if (data) {
                let dt1 = new Date(
                                    parseInt(data.substr(6,4)),
                                    (parseInt(data.substr(3,2)) - 1),
                                    parseInt(data.substr(0,2)),
                                    parseInt(data.substr(11,2)),
                                    parseInt(data.substr(14,2))
                                    )
                let dt2 = new Date()
                let resultado = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
            
                if (resultado < 15) return `<button type="button" class="btn btn-success btn-sm">${resultado} dias</button>` 
                if (resultado < 35) return `<button type="button" class="btn btn-warning btn-sm">${resultado} dias</button>` 
                if (resultado >= 35) return `<button type="button" class="btn btn-danger btn-sm">${resultado} dias</button>` 
            }
        }
    }
}
</script>

<style>

</style>